import { useTranslate } from "@core/hooks"
import { useSubscription } from "../context";
import {
  getStoragePercent,
  formatBytes,
  isStorageWarning,
  isStorageCritical,
  isStorageFull,
} from "../utils";
import { Icon } from "@core/components";

export const StorageIndicator = () => {
  const { t } = useTranslate("workspace")
  const { subscription } = useSubscription();
  const { storage_used, storage_total } = subscription;

  const percent = getStoragePercent(storage_used, storage_total);
  const isFull = isStorageFull(storage_used, storage_total);
  const isCritical = isStorageCritical(storage_used, storage_total);
  const isWarning = isStorageWarning(storage_used, storage_total);

  const stateColor =
    isFull || isCritical
      ? "text-accent-red-800"
      : isWarning
        ? "text-accent-yellow-600"
        : "text-secondary-900";

  const barColor =
    isFull || isCritical
      ? "bg-accent-red-800"
      : isWarning
        ? "bg-accent-yellow-600"
        : "bg-primary-600";

  return (
    <div className="flex items-center gap-2.5 bg-neutral-50 border border-neutral-200 rounded-lg px-3 py-1 min-w-[220px]">
      <Icon
        name="database"
        className={`size-[18px] ${stateColor}`}
        strokeWidth={1.6}
      />
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        <div className="flex items-center justify-between">
          <span className="text-xs font-medium text-secondary-900 whitespace-nowrap">
            {t("subscription.storage.used", {
              used: formatBytes(storage_used),
              total: formatBytes(storage_total),
            })}
          </span>
          <span
            className={`text-xs font-semibold whitespace-nowrap ml-2 ${stateColor}`}
          >
            {percent}%
          </span>
        </div>
        <div className="w-full h-[5px] bg-neutral-200 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full ${barColor}`}
            style={{ width: `${percent}%` }}
          />
        </div>
      </div>
    </div>
  );
};
